import React from 'react'
import HeaderMenu from '../publicComponents/headerMenu'
import OtherFooterMenu from '../publicComponents/otherFooterMenu'
import BreadCrums from '../publicComponents/breadcrums'
import DuaContent from '../publicComponents/duaContent'

export class Dua extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    componentDidMount() {
        this._ismounted = true;
    }

    componentWillUnmount() {
        this._ismounted = false;
    }
    render() {
        return (
            <div>
                <HeaderMenu />
                <BreadCrums pageName="Dua's" />
                <div className="wrapper">
                    <DuaContent />
                </div>
                <OtherFooterMenu />
            </div >
        )
    }
}
export default Dua